import * as yup from "yup";

export const getDateTime = (dateObj) => {
  const date =
    dateObj.getFullYear() +
    "-" +
    (dateObj.getMonth() + 1) +
    "-" +
    dateObj.getDate();
  const time =
    dateObj.getHours() +
    ":" +
    dateObj.getMinutes() +
    ":" +
    dateObj.getSeconds();
  return time + " " + date;
};

export const getFormikError = (fieldName, { errors, touched }) =>
  touched[fieldName] && errors[fieldName];

const BASE_TIME_SCHEMA = yup.number().integer().min(0).required();
const HOURS_SCHEMA = BASE_TIME_SCHEMA.max(23);
const MINUTES_SCHEMA = BASE_TIME_SCHEMA.max(59);

export const VALIDATION_SCHEMA = yup.object().shape({
  checkInterval: yup.number().min(1).required(),
  departureTimes: yup
    .string()
    .required()
    .test("valid-format", "Вводите данные в формате: ЧЧ:ММ, ЧЧ:ММ", (value) => {
      if (!value) {
        return true;
      }
      const times = value.split(",");
      for (const time of times) {
        const trimmedTime = time.trim();
        const [hours, minutes] = trimmedTime.split(":");
        if (
          !hours ||
          !minutes ||
          !HOURS_SCHEMA.isValidSync(hours) ||
          !MINUTES_SCHEMA.isValidSync(minutes)
        ) {
          return false;
        }
      }
      return true;
    }),
  stationFrom: yup.string().required(),
  stationTo: yup.string().required(),
  departureDate: yup.date().required(),
  telegramChatId: yup.number(),
  ticketPriceMin: yup.number(),
  ticketPriceMax: yup.number(),
});

export const getSavedSettings = () => {
  const savedSettings = localStorage.getItem("settings");
  try {
    return JSON.parse(savedSettings);
  } catch (e) {
    return null;
  }
};

const DEFAULT_SETTINGS = {
  checkInterval: 1,
  departureTimes: [],
  stationFrom: "",
  stationTo: "",
  departureDate: "",
  telegramChatId: "",
  ticketPriceMin: undefined,
  ticketPriceMax: undefined,
};

export const getInitialSettings = () => {
  if (typeof Storage !== "undefined") {
    let savedSettings = getSavedSettings();
    return savedSettings || DEFAULT_SETTINGS;
  } else {
    return DEFAULT_SETTINGS;
  }
};

export const saveSettings = (settings) => {
  if (typeof Storage !== "undefined") {
    localStorage.setItem("settings", JSON.stringify(settings, null, 2));
  }
};

export const getSearchParams = (settings) => {
  const {
    departureTimes,
    stationFrom,
    stationTo,
    departureDate,
    telegramChatId,
    ticketPriceMin,
    ticketPriceMax,
  } = settings;
  const castedTimes = departureTimes.split(",").map((time) => time.trim());
  return {
    departure_times: castedTimes,
    from_station: stationFrom,
    to_station: stationTo,
    search_date: departureDate,
    chat_id: telegramChatId || undefined,
    ticket_price_min: ticketPriceMin || undefined,
    ticket_price_max: ticketPriceMax || undefined,
  };
};
